import axios from 'axios';
import emitter from '@/utils/eventBus';
import { v4 as uuidv4 } from 'uuid';
let requestId = localStorage.getItem('requestId');
if(!requestId){
  requestId = uuidv4();
  localStorage.setItem('requestId', requestId);
}
// 创建一个 Axios 实例
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8888', // 使用环境变量或默认值
  headers: {
    'Content-Type': 'application/json',
  },
});
let isRefreshing = false;
let refreshSubscribers = [];
// 请求拦截器
apiClient.interceptors.request.use(config => {
//   if (process.env.NODE_ENV === 'development') {
    // 在开发环境中使用 JWT
    const token = localStorage.getItem('token');
    if (token) {
        const tokenExp = localStorage.getItem('tokenExp');
        if(tokenExp*1000 < Date.now()){
             localStorage.removeItem('token');
             localStorage.removeItem('tokenExp');
             localStorage.removeItem('tokenIat');
             localStorage.removeItem('tokenJti');
             localStorage.removeItem('userProfile');
        }else {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    config.headers['X-Request-Id'] = requestId;
    const locale = localStorage.getItem('language') || 'en';
    config.headers['Accept-Language'] = locale;
//   }
  // 在生产环境中，依赖于 WordPress 的 Cookie
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
apiClient.interceptors.response.use(response => {
    const token = response.headers['x-token-status'];
    if(token === 'near_expiry' && !isRefreshing){
      // 通知客户端更新 token
      isRefreshing = true;
      refreshToken();
      return new Promise((resolve) => {
        subscripeTokenRefresh(token => {
            response.config.headers.Authorization = `Bearer ${token}`;
            resolve(apiClient(response.config));
        });
      });
    } else if(token === 'Not logined'){
      localStorage.removeItem('token');
      localStorage.removeItem('tokenExp');
      localStorage.removeItem('tokenIat');
      localStorage.removeItem('tokenJti');
      localStorage.removeItem('userProfile');
      emitter.emit('user-logout');
    }
  return response;
}, error => {
  if (error.response) {
    // 服务器返回了一个状态码，超出了 2xx 范围
    console.error('Error response:', error.response.data);
    console.error('Error status:', error.response.status);
  } else if (error.request) {
    // 请求已发出，但没有收到响应
    console.error('Error request:', error.request);
  } else {
    // 其他错误
    console.error('Error message:', error.message);
  }
  return Promise.reject(error);
});

// 令牌更新函数
function refreshToken() {
    // 假设有一个刷新令牌的 API 端点
    apiClient.post('/wp-json/custom/v1/refresh-token')
        .then(response => {
            const newToken = response.data.token;
            // 更新本地存储中的令牌
            localStorage.setItem('token', newToken);
            isRefreshing = false;
            onRefreshed(newToken);
        })
        .catch(error => {
            console.error('Error refreshing token:', error);
            isRefreshing = false;
            // 处理刷新令牌失败的情况
        });
}
function subscripeTokenRefresh(callback){
    refreshSubscribers.push(callback);
}
function onRefreshed(token){
    refreshSubscribers.forEach(callback => callback(token));
    refreshSubscribers = [];
}
export default apiClient; 